import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import TextInput from 'screens/components/basic/TextInput';
import CardSimple from 'screens/components/basic/CardSimple';
import CheckInput from 'screens/components/basic/CheckInput';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class HowtoSave extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.admin.writing.howTo.link}>{LOOKUP.menu.admin.writing.howTo.text}</Link></li>
                    <li className="active">{LOOKUP.menu.admin.writing.howTo.edit.text}</li>
                </ol>
                <h2>{LOOKUP.menu.admin.writing.howTo.edit.text}</h2>
            </div>
        );

        return (
            <div>
                <ContainerDivided headerContent={header}>
                    <CardSimple>
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    fullWidth={true}
                                    name="howToTItle"
                                    floatingLabelText={LOOKUP.menu.admin.writing.howTo.edit.title.label}
                                    hintText={LOOKUP.menu.admin.writing.howTo.edit.title.hintText}
                                    maxLength={50} />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    fullWidth={true}
                                    name="howToSummary"
                                    floatingLabelText={LOOKUP.menu.admin.writing.howTo.edit.instruction.label}
                                    hintText={LOOKUP.menu.admin.writing.howTo.edit.instruction.hintText}
                                    multiLine={true} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="ml-2 mt-3"><CheckInput name="step1" text="Step 1" /></div>
                            <div className="col-xs-12 col-sm-12 col-md-11 col-lg-11 col-xl-11">
                                <Editor
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="faq_answer_dialog"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="ml-2 mt-3"><CheckInput name="step2" text="Step 2" /></div>
                            <div className="col-xs-12 col-sm-12 col-md-11 col-lg-11 col-xl-11">
                                <Editor
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="faq_answer_dialog"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="ml-2 mt-3"><CheckInput name="step3" text="Step 3" /></div>
                            <div className="col-xs-12 col-sm-12 col-md-11 col-lg-11 col-xl-11">
                                <Editor
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="faq_answer_dialog"
                                />
                            </div>
                        </div>
                    </CardSimple>
                    <br />
                    <div className="row">
                        <div className="col-lg-12">
                            <Button name="buttonSave"
                                className="pull-right"
                                label={LOOKUP.menu.admin.coupon.controls.saveButton}
                                primary={true} />
                            <Button name="buttonCancel"
                                className="pull-right btn-space"
                                label={LOOKUP.common.cancel.text} />
                        </div>
                    </div>
                </ContainerDivided>
            </div>
        );
    }
}


export default HowtoSave;